<template>
    <div>
        <div class="top" :style="pageShow ? 'left:300px; width:calc(100% - 300px);' : 'left:0; width:100%;'">
            <div class="tleft">
                <!-- <img src="../assets/img/tophide.png" />
                首页 -->
            </div>
            <div class="tright">
                <img class="pic" src="../assets/img/def_pic.png" />
                <div v-if='userInfo'>{{userInfo.real_name}}</div>
                <div v-else>游客</div>
                <img class="exit" @click="exit()" src="../assets/img/topexit.png" />
            </div>
        </div>

        <div class="left" :style="pageShow ? 'left:0' : 'left:-300px'">
            <div class='onOff open' :class="pageShow ? 'close' : 'open'" @click='switchPage()'></div>
            <div class="ltop">
                <!-- <img src="../assets/img/logo.png" /> -->
                <img :src='mingcheng.pic'/>

            </div>
            <div class="lbtm">
                <img class="tbg" src="../assets/img/lefttop.png"/>
                <img class="bbg" src="../assets/img/leftbtm.png"/>
                <div class="item">
                    <div class="itop" @click="check('','','',0,'')" :class="(is_home ? 'selected' : '')">
                        <img src="../assets/img/left1.png"/>
                        首页
                    </div>
                </div>
                
                <div class="item" :class="(v.is_show ? 'show' : '') + ' ' + (v.is_now ? 'now' : '')" v-for="(v,k) in nav" :key='k' @click='show(k)'>
                    <div class="itop" :class="(v.is_check ? 'selected' : '')">
                        <!-- <img src="../assets/img/left1.png"/>  -->
                        <img :src="v.picurl"/>
                        {{v.name}}
                    </div>
                    <div class="iinfo" >
                        <div class='two_box' v-for='(vv,kk) in v.son' :key='kk' >
                            <div class="two_title" :class="((vv.is_show ? 'show' : '')+' '+(vv.is_check ? 'selected' : ''))" @click.stop='show_two(k,kk)'>{{vv.title}}</div>
                            <div class="two_list" v-show="vv.is_show">
                                <span v-for='(vvv,kkk) in vv.erji' @click.stop='check(k,kk,kkk,vvv.id,vvv.title)' :class="(vvv.is_check ? 'selected' : '')">{{vvv.title}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="item show">
                    <div class="itop">
                        <img src="../assets/img/left2.png"/>
                        规模与人口
                    </div>
                    <div class="iinfo">
                        <div>行政区域土地面积</div>
                        <div>户籍人口</div>
                        <div>常住人口</div>
                    </div>
                </div>
                <div class="item">
                    <div class="itop">
                        <img src="../assets/img/left3.png"/>
                        规模与人口
                    </div>
                    <div class="iinfo">
                        <div>行政区域土地面积</div>
                        <div>户籍人口</div>
                        <div>常住人口</div>
                    </div>
                </div> -->
            </div>
            
        </div>
    </div>
</template>

<script>
// import {homePic} form '../assets/img/left1.png';
import left1img from "../assets/img/left1.png";
import left2img from "../assets/img/left2.png";
import left3img from "../assets/img/left3.png";
import left4img from "../assets/img/left4.png";
export default {
    name: "Menu",
    data() {
        return {
            nav:[],
            is_home:0,
        };
    },
    mounted(){
        let id = window.location.href.split('/')[window.location.href.split('/').length-2];
        this.getNav(id);

    },
    methods:{
        switchPage(){
            this.$store.commit('SET', {pageShow: !this.pageShow});
        },
        async getNav(id = '#'){
            
            this.is_home = (id == '#') ? 1 : 0


            let nav = [];

            let pro = await this.$post('/api/service_type',{type:1});
            let area = await this.$post('/api/service_type',{type:2});
            let city = await this.$post('/api/service_type',{type:3});

            let check_type = '';

            let state = false;
            for(let i in pro.data){
                pro.data[i].is_show = 0;
                pro.data[i].is_check = 0;
                if(pro.data[i].title == '省'){
                    pro.data.splice(i,1);// break;
                }
                for(let ii in pro.data[i].erji){
                    pro.data[i].erji[ii].is_check = 0;
                    if(pro.data[i].erji[ii].id == id) {
                        this.$store.commit('SET', {infoTitle:  pro.data[i].erji[ii].title});
                        pro.data[i].erji[ii].is_check = 1;
                        state = [i,ii];
                    }
                    if(state && state[1] == i && state[2] == ii) pro.data[i].erji[ii].is_check = 1;
                }
                if(state && state[1] == i){ pro.data[i].is_check = 1; pro.data[i].is_show = 1; }
            }
            if(state) check_type = 'pro';
            state = 0;
            for(let i in area.data){
                area.data[i].is_show = 0;
                area.data[i].is_check = 0;
                if(area.data[i].title == '市'){
                    area.data.splice(i,1);// break;
                }
                for(let ii in area.data[i].erji){
                    area.data[i].erji[ii].is_check = 0;
                    if(area.data[i].erji[ii].id == id) {
                        this.$store.commit('SET', {infoTitle:  area.data[i].erji[ii].title});
                        area.data[i].erji[ii].is_check = 1;
                        state = [i,ii];
                    }
                    if(state && state[1] == i && state[2] == ii) area.data[i].erji[ii].is_check = 1;
                }
                if(state && state[1] == i){ area.data[i].is_check = 1; area.data[i].is_show = 1;}
            }
            if(state) check_type = 'area';
            state = 0;
            for(let i in city.data){
                city.data[i].is_show = 0;
                city.data[i].is_check = 0;
                if(city.data[i].title == '区'){
                    city.data.splice(i,1);// break;
                }
                for(let ii in city.data[i].erji){
                    city.data[i].erji[ii].is_check = 0;
                    if(city.data[i].erji[ii].id == id) {
                        this.$store.commit('SET', {infoTitle:  city.data[i].erji[ii].title});
                        city.data[i].erji[ii].is_check = 1;
                         state = [i,ii];
                    }
                    if(state && state[1] == i && state[2] == ii) city.data[i].erji[ii].is_check = 1;
                }
                if(state && state[1] == i){ city.data[i].is_check = 1; city.data[i].is_show = 1;}
            }
            if(state) check_type = 'city';

            nav[0] = {name:'省级指标', is_show:(check_type == 'pro' ? 1 : 0),is_check:(check_type == 'pro' ? 1 : 0), picurl:left2img, son:pro.data};
            nav[1] = {name:'市级指标', is_show:(check_type == 'area' ? 1 : 0),is_check:(check_type == 'area' ? 1 : 0), picurl:left3img, son:area.data};
            nav[2] = {name:'区/县级指标', is_show:(check_type == 'city' ? 1 : 0),is_check:(check_type == 'city' ? 1 : 0), picurl:left4img, son:city.data};
            console.log(nav);
            this.nav = nav;
        },
        check(i1,i2,i3, id, title){
            for(let i in this.nav){
                this.nav[i].is_check = (i == i1) ? true : false;
                for(let ii in this.nav[i].son){
                    this.nav[i].son[ii].is_check = (i == i1 && ii == i2) ? true : false;
                    for(let iii in this.nav[i].son[ii].erji){
                         this.nav[i].son[ii].erji[iii].is_check = (i == i1 &&  ii == i2 && iii == i3) ? true : false;
                    }
                }
            } 
            // return;
            this.is_home = (id == 0) ? 1 : 0
            if(id == 0){
                this.$router.push('/home');
                return; 
            }
            console.log(title);
            this.$store.commit('SET', {infoTitle: title});
            this.$router.push('/info/'+id+'/'+(i1+1));
        },
        show(index){
            let nav = this.nav;
            for(let i in nav){
                nav[i].is_show = (index == i) && nav[i].is_show==false ? true : false;
            }
            this.nav = nav;
        },
        show_two(i, ii){
            
            // console.log(this.nav);
            // console.log(i, this.nav[i]);
            // console.log(ii, this.nav[i].son[ii]);
            this.nav[i].son[ii].is_show = !this.nav[i].son[ii].is_show;
            return;
            let nav = this.nav;
            for(let i in nav){
                nav[i].is_show = (index == i) && nav[i].is_show==false ? true : false;
            }
            this.nav = nav;
        },
        exit(){
            localStorage.clear();
            window.location.href='/';
        }
        
    }
};
</script>


<style lang="scss" scoped>
.top {
    width: calc(100% - 300px);
    height: 60px;
    position: absolute;
    top: 0;
    left: 300px;
    float: right;
    background: #e6212a;
    // height:100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 40px;
    z-index:100;
    transition: all .3s;

    .tleft {
        color: #fff;
        font-size: 16px;
        img {
            width: 24px;
            float: left;
            margin-right: 10px;
        }
    }
    .tright {
        width: 300px;
        position: relative;
        background: #0756a5;
        display: flex;
        align-items: center;
        justify-content: space-around;
        height: 100%;
        float: right;
        padding: 0 40px;
        // font-size:16px;

        &::before {
            content: " ";
            border-top: 80px solid #0756a5;
            border-left: 60px solid transparent;
            display: block;
            position: absolute;
            left: -60px;
            top: -20px;
        }
        .pic {
            height: 40px;
            width: 40px;
            border-radius: 50%;
            background: #fff;
            margin-right: 10px;
        }
        div {
            flex: 1;
            color: #fff;
            font-size: 18px;
            // &::after {
            //     content: "";
            //     display: inline-block;
            //     height: 8px;
            //     width: 8px;
            //     border-top: solid 2px #fff;
            //     border-right: solid 2px #fff;
            //     transform: rotate(135deg);
            //     position: relative;
            //     top: -3px;
            //     left: 10px;
            // }
        }
        .exit {
            float: right;
            cursor:pointer
        }
    }
}

.left {
    width: 300px;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    z-index:100;
    transition: all .3s;
    


    .onOff{
        cursor:pointer;
        position:absolute;
        right:-10px;
        width:10px;
        height:50px;
        top:calc(50% - 25px);
        background: #999;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        &.open{
            &::before{
                content:" ";
                position: absolute;
                top:calc(50% - 3px);
                height:5px;
                width:5px;
                border-top:solid 1px #fff;
                border-right:solid 1px #fff;
                transform: rotate(45deg);
            }
        }
        &.close{
            &::before{
                content:" ";
                position: absolute;
                top:calc(50% - 3px);
                height:5px;
                width:5px;
                border-top:solid 1px #fff;
                border-right:solid 1px #fff;
                transform: rotate(-135deg);
                left:3px;
            }
        }
    }

    .ltop {
        width: 300px;
        height: 60px;
        background: #0756a5;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 20rpx;
        img {
            max-height: 100%;
            max-width: 100%;
        }
    }
    .lbtm{
        height:calc(100vh - 60px);
        width:100%;
        z-index:1;
        position:relative;
        padding-top:24px;
        overflow-y:scroll;

        &::-webkit-scrollbar { /*滚动条整体样式*/ width:4px;/*高宽分别对应横竖滚动条的尺寸*/ height:1px; }
        &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
            background: #ccc;
        }
        &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
            border-radius: 10px;
            background: #ededed;
        }


        // .selected{
        //     // border-bottom:: #ccc !important;
        //     position:relative;
        //     &:after{
        //         content:" ";
        //         position:absolute;
        //         height:4px;
        //         width:100%;
        //         background: #338FE2;
        //         left:0;
        //         bottom:10px;
        //     }
        // }
        .tbg{
            position: absolute;
            width:100%;
            z-index:-1;
            top:0;
            left:0;
        }

        .bbg{
            position: absolute;
            width:100%;
            z-index:-1;
            bottom:0;
            left:0;
        }
        .item{
            height:76px;
            overflow:hidden;
            .itop{
                height:52px;
                line-height:52px;
                padding-left:86px;
                color:#333;
                font-size:16px;
                position: relative;
                margin:12px 0;
                border-left:4px solid rgba(0,0,0,0);
                cursor: pointer;
                transition:all .3s;
                &::before{
                    content:" ";
                    position: absolute;
                    border-top:2px solid #868686;
                    border-right:2px solid #868686;
                    height:8px;
                    width:8px;
                    transform: rotate(45deg);//rotate(135deg);
                    top:22px;
                    right:28px;
                    transition:all .3s;
                }
                img{
                    float:left;
                    position:absolute;
                    margin-right:40px;
                    top:13px;
                    left:24px;
                    height:22px;
                }
                &.selected{
                    border-color:#338FE2;
                }
            }

            // &.selected{
            //     .itop{
                    
            //     }
            // }

            
            .iinfo{
                padding:10px 0;
                border-top: solid 1px #EAEAEA;
                line-height:60px;
                cursor: pointer;
                // transform: scaleY(0);
                position: relative;
                // margin-top:-50%;
                // top:-100%;
                // margin-bottom:-50%;
                // transition:all .3s;

                .two_box{
                    // text-align: center;
                    text-align: left;
                    padding-left:30px;
                    color:#999;

                    .two_title{
                        position:relative;
                        font-size:15px;
                        &::before{
                            content:" ";
                            position: absolute;
                            border-top:2px solid #868686;
                            border-right:2px solid #868686;
                            height:8px;
                            width:8px;
                            transform: rotate(45deg);//rotate(135deg);
                            top:22px;
                            right:50px;
                            transition:all .3s;
                        }
                        &.show{
                            &::before{
                                top:18px;
                                transform: rotate(135deg);
                            }
                        }
                        &.selected{
                            color:#333;
                            font-size:16px;
                            font-weight:bold;

                        }
                    }


                    span{
                        display: block;
                        position: relative;
                        padding-left:30px;
                        font-size:12px;
                        // text-align: left;
                        color:#333;
                        &::before{
                            background: #ccc;
                            height:12px;
                            width:12px;
                            border-radius:50%;
                            content:" ";
                            position: absolute;
                            top:24px;
                            left:0px;
                        }
                        &.selected{
                            &::before{
                                background: #EE516E;
                            }
                        }
                    }
                    
                }
            }
            &.show{
                height:auto;
                .iinfo{
                    // transform: scaleY(1);
                    // margin:0;
                    // top:0;
                }
                .itop{
                    &::before{
                        top:18px;
                        transform: rotate(135deg);
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue